import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const TRACKER_SRC = 'https://audinexa.com/api/track.js';
const PUBLIC_EXACT = ['/', '/legacy-landing', '/signup', '/terms', '/privacy', '/refund', '/contact', '/referral-terms', '/status'];

export const isMarketingPath = (p) => PUBLIC_EXACT.includes(p) || p === '/demo' || p.startsWith('/demo/');

export function useMarketingTracker() {
  const { pathname } = useLocation();
  useEffect(() => {
    const isPublic = isMarketingPath(pathname);
    // Paused flag stops the tracker's SPA pageviews once a visitor enters the clinic app.
    window.__axaPaused = !isPublic;
    if (!isPublic || document.querySelector(`script[src="${TRACKER_SRC}"]`)) return;
    const s = document.createElement('script');
    s.src = TRACKER_SRC;
    s.defer = true;
    s.setAttribute('data-testid', 'audinexa-tracker-script');
    document.head.appendChild(s);
  }, [pathname]);
}

export function trackCta(name, extras) {
  try {
    if (typeof window.audinexaTrack === 'function') window.audinexaTrack(name, extras);
  } catch (e) { /* tracking must never break a CTA */ }
}
